"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      breakpoints = _ref.breakpoints;
  return {
    wrapper: {
      backgroundColor: palette.grey.A400,
      color: palette.primary.contrastText
    },
    iconWrapper: _defineProperty({
      marginTop: '20px'
    }, breakpoints.up('md'), {
      marginTop: 0
    }),
    link: {
      color: palette.primary.contrastText,
      textDecoration: 'none'
    }
  };
});
var _default = useStyles;
exports["default"] = _default;